import React, { useEffect, useMemo, useState } from 'react'
import ModalFilterItem from '../Components/ModalFilterItem';
import { useSelector } from 'react-redux';
import MonthDD from '../../../../utils/MonthDD';
import isNull from '../../../../utils/NullChecking';
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList';
import CalendaRangeInput from '../../../General/CalendarRangeInput';

export const last12Months = () => {
  let currMonth = new Date().getMonth();
  let currYear = new Date().getFullYear();
  let months = [
    ...MonthDD.slice(currMonth + 1, 12).map(month => `${month} - ${currYear - 1}`),
    ...MonthDD.slice(0, currMonth + 1).map(month => `${month} - ${currYear}`)
  ].reverse().map(month => ({ display: month, value: month }));
  return months;
};

const useDashboardFilterHook = (LoadData, name, setApplyAllModal, applyAllModal, extraSearchCriteria = {}, onReset = () => {}) => {
  const months = last12Months();
  const [is, setIs] = useState(true);
  const providersReducer = useSelector((state) => { return state?.GeneralDropDownsReducer });
  let isHomecareOrADC = useSelector(state => ["Adult Day Care", "Homecare Agency"].includes(state.GeneralDropDownsReducer.PracticeType))
  const filteredProviders = Array.isArray(providersReducer?.Provider)
    ? providersReducer.Provider.filter((item) => item?.value !== -1)
    : [];
  const providersList = [
    ...filteredProviders
  ];
  const filteredLocation = Array.isArray(providersReducer?.Location)
    ? providersReducer.Location.filter((item) => item?.value !== -1)
    : [];
  const locationsList = [
    ...filteredLocation
  ];
  const filteredInsurance = Array.isArray(providersReducer?.Insurance)
    ? providersReducer.Insurance.filter(item => !['-1', -1, "SELFPAY"].includes(item.value))
    : [];

  const insurancesList = [
    ...filteredInsurance
  ];
  const paymentForList = [{ value: 'System Visits', display: 'System Visits' }, { value: 'External Visits', display: 'External Visits' }, { value: 'All', display: 'All' },];

  const basedOnList = [
    ...(['Line Chart', 'Financial Summary', 'Billing Performance', 'Aging_Payment_Received'].includes(name) ?
      [{ value: "EntryDate", display: "Entry Date" },
      { value: "DOS", display: "Date of Service" },
      { value: "SubmittedDate", display: "Submitted" }] :
      name === 'Payment Received' ?
        [{ value: "EntryDate", display: "Entry Date" },
        { value: "DOS", display: "Date of Service" },
        { value: "CheckDate", display: "Check Date" },
        { value: "DepositDate", display: "Deposit Date" },
        { value: "PostedDate", display: "Posted Date" }] :
        [])
  ];

  const [reloadItem, setReloadItem] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [showFilterOptions, setShowFilterOptions] = useState({});
  const [basedOnDateFinancial, setBasedOnDateFinancial] = useState(['Financial Summary', 'Billing Performance', 'Line Chart', 'Aging_Payment_Received'].includes(name) ? "DOS" : "EntryDate");
  const DEFAULT_SEARCH_MODAL = {
    "DateTo": "",
    "DateFrom": "",
  }
  // const [searchParamDate, setSearchParamDate] = useState(DEFAULT_SEARCH_MODAL);

  const [monthYearVal, setMonthYearVal] = useState(months?.[0]?.value);
  const [basedOnDfltSlctdItmFinancial, setBasedOnDfltSlctdItmFinancial] = useState([
    ['Financial Summary', 'Billing Performance', 'Line Chart'].includes(name) ? { value: "DOS", display: "Date of Service" } : { value: "EntryDate", display: "Entry Date" },]);
  const [insuranceID, setInsuranceID] = useState('');
  const [insuranceDfltSlctdItm, setInsuranceDfltSlctdItm] = useState([]);
  const [locationID, setLocationID] = useState('');
  const [locationDfltSlctdItm, setLocationDfltSlctdItm] = useState([]);
  const [providerID, setProviderID] = useState('');
  const [providerDfltSlctdItm, setProviderDfltSlctdItm] = useState([]);
  const [paymentForID, setPaymentForID] = useState('All');
  const [paymentForDfltSlctdItm, setPaymentForDfltSlctdItm] = useState([{ value: 'All', display: 'All' }]);

  const resetFinancialSummaryFilter = () => {
    setShowFilterOptions({})
    // setDateRange(null);
    // setSearchParamDate(DEFAULT_SEARCH_MODAL)
    setMonthYearVal(months?.[0]?.value)
    setPaymentForID('All');
    setBasedOnDateFinancial(['Financial Summary', 'Billing Performance', 'Line Chart'].includes(name) ? "DOS" : "EntryDate");
    setBasedOnDfltSlctdItmFinancial([
      ['Financial Summary', 'Billing Performance', 'Line Chart'].includes(name) ? { value: "DOS", display: "Date of Service" } : { value: "EntryDate", display: "Entry Date" },]);
    setInsuranceID('');
    setLocationID('');
    setProviderID('');
    setPaymentForDfltSlctdItm([{ value: 'All', display: 'All' }]);
    setInsuranceDfltSlctdItm([]);
    setLocationDfltSlctdItm([]);
    setProviderDfltSlctdItm([]);
    setReloadItem(prev => !prev);
    onReset?.();   // <-- new
  }
  /// handleApplyAll ///
  const handleApply = (name) => {
    if (name === 'Line Chart') {
      setApplyAllModal(prev => ({ ...prev, BasedOn: basedOnDfltSlctdItmFinancial?.[0] }))
    } else {
      if (name === 'Payment Line Chart') {
        LoadData(name, 'PaymentFor');
      } else if (['Billing Performance'].includes(name)) {
        LoadData('Billing Performance 0');
        LoadData('Billing Performance 1');
        LoadData('Billing Performance 2');
      } else {
        LoadData(name);
      }
    }
    setOpenFilter(false);
  }
  const handleApplyAll = () => {
    setApplyAllModal(prev => ({ ...prev, BasedOn: basedOnDfltSlctdItmFinancial?.[0] }))
    setOpenFilter(false);
  }

  useEffect(() => {
    if (!applyAllModal) return;
    let itemBasedOn = name === "Payment Received" ?
      (applyAllModal.BasedOn.value === "SubmittedDate" ?
        { value: "DOS", display: "Date of Service" } :
        applyAllModal.BasedOn) :
      applyAllModal.BasedOn;

    searchFilterModal.SearchCriteria.Value = itemBasedOn.value;
    setBasedOnDateFinancial(itemBasedOn.value);
    setBasedOnDfltSlctdItmFinancial([itemBasedOn]);
    LoadData(name);
  }, [applyAllModal])

  const monthYear = useMemo(() => {
    const [month, year] = monthYearVal ? monthYearVal.split(" - ") ?? ["", ""] : ["", ""];
    const monthIndex = MonthDD.findIndex(item => item === month);
    let monthNumber = monthIndex >= 0 ? String(monthIndex + 1) : "";
    return { monthNumber, year };
  }, [monthYearVal]);

  const handleSelectedData = (selectedData, name, type) => {
    if (type === 'client' && !isNull(selectedData)) {
      if (name === 'Months') {
        setMonthYearVal(selectedData.value)
      }
    }
    else {
      setMonthYearVal('')
    }
  }
  const handleChangeDD = (e, name) => {
    const value = e.target.value;
    if (name === 'Months') {
      setMonthYearVal(value);
    }
  }
  ////////////////// Date Range ////////////////////
  // const [dateRange, setDateRange] = useState(null);
  // const getCurrentDateRange = (dateFrom, dateTo) => {
  //   return {
  //     formattedStartDate: searchParamDate?.DateFrom || null,
  //     formattedEndDate: searchParamDate?.DateTo || null
  //   };
  // };

  // useEffect(() => {
  //   if (!openFilter || !['Billing Performance'].includes(name)) return;
  //   const currentWeekDates = getCurrentDateRange();
  //   if (currentWeekDates?.formattedStartDate) {
  //     setDateRange(`${currentWeekDates.formattedStartDate}-${currentWeekDates.formattedEndDate}`);
  //   }
  // }, [openFilter]);
  /////////////////////
  let filterDiv = openFilter ?
    <div className="ar_dash-filter-pop-up d-flex flex-column gap-10">
      <div className="d-flex align-items-center justify-content-between px-12 pb-1 br-bottom-1 za_br_light">
        <p className="heading dark-clr">Filter by</p>
        <div className="app_tooltip left">
          <i className="icon-x-cros fs-16 fw-900 dark-clr" onClick={() => setOpenFilter(false)}></i>
          <p className="tool_tip xsm_text text-light">Close</p>
        </div>

      </div>
      <div className="d-flex flex-column gap-2 px-10 multipleSearch-rounded">
        <>
          {/* Date Range */}
          {/* {['Billing Performance'].includes(name) ?
            <div>
              <p className="text pb-3px">Date</p>
              <CalendaRangeInput
                searchParam={searchParamDate}
                setSearchParam={setSearchParamDate}
                defaultDates={dateRange}
                options={['Date']}
                label={false}
              />
            </div> : <></>} */}
          {/* Month */}
          {['Line Chart'].includes(name) ?
            <>
              <div className="input">
                <SuperSearchList
                  type="client"
                  id='Months'
                  name='Months'
                  searchValue={monthYearVal}
                  data={months}
                  onChange={(e) => handleChangeDD(e, 'Months')}
                  getSelectedData={handleSelectedData}
                  is={is}
                  icon={'Simple'}
                  sup_btn='sup_btn'
                  sup_inp='superSearchVisitInp'
                />
              </div>
            </> : <></>}
          {/* Based on */}
          {['Line Chart Main', 'Payment Line Chart', 'Financial Summary', 'Billing Performance', 'Aging_Payment_Received'].includes(name) ? <></> :
            <div>
              <ModalFilterItem
                key={reloadItem}
                label={'Based on'}
                type={'BasedOn'}
                ItemLists={basedOnList}
                setSelectedIDs={setBasedOnDateFinancial}
                showFilterOptions={showFilterOptions}
                defaultSelectedItems={basedOnDfltSlctdItmFinancial}
                setDefaultSelectedItem={setBasedOnDfltSlctdItmFinancial}
              />
              {/* {name === 'Line Chart' && <button className="btn btn-add" onClick={handleApplyAll}>Apply All</button>} */}
            </div>}
          {/* Insurance */}
          {['Line Chart Main', 'Line Chart', 'Payment Line Chart'].includes(name) ? <></> :
            <div>
              <ModalFilterItem
                key={reloadItem}
                label={'Insurance'}
                type={'Insurance'}
                ItemLists={insurancesList}
                setSelectedIDs={setInsuranceID}
                showFilterOptions={showFilterOptions}
                defaultSelectedItems={insuranceDfltSlctdItm}
                setDefaultSelectedItem={setInsuranceDfltSlctdItm}
                selectType={'multiple'}

              />
            </div>}
          {/* Location */}
          {['Payment Received', 'Line Chart', 'Payment Line Chart'].includes(name) ? <></> :
            <div>
              <ModalFilterItem
                key={reloadItem}
                label={'Location'}
                type={'Location'}
                ItemLists={locationsList}
                setSelectedIDs={setLocationID}
                showFilterOptions={showFilterOptions}
                defaultSelectedItems={locationDfltSlctdItm}
                setDefaultSelectedItem={setLocationDfltSlctdItm}
                selectType={'multiple'}

              />
            </div>}
          {/* Provider */}
          {([...(isHomecareOrADC ? ['Financial Summary', 'Billing Performance', 'Aging_Payment_Received'] : []), 'Payment Received', 'Line Chart', 'Payment Line Chart']).includes(name) ? <></> :
            <div>
              <ModalFilterItem
                key={reloadItem}
                label={'Provider'}
                type={'Provider'}
                ItemLists={providersList}
                setSelectedIDs={setProviderID}
                showFilterOptions={showFilterOptions}
                defaultSelectedItems={providerDfltSlctdItm}
                setDefaultSelectedItem={setProviderDfltSlctdItm}
                selectType={'multiple'}
              />
            </div>}
          {/* Payment For */}
          {['Line Chart Main', 'Financial Summary', 'Billing Performance', 'Payment Received', 'Aging_Payment_Received'].includes(name) ? <></> : <div>
            <ModalFilterItem
              key={reloadItem}
              label={'Payment For'}
              type={'PaymentFor'}
              ItemLists={paymentForList}
              setSelectedIDs={setPaymentForID}
              showFilterOptions={showFilterOptions}
              defaultSelectedItems={paymentForDfltSlctdItm}
              setDefaultSelectedItem={setPaymentForDfltSlctdItm}
            />
          </div>
          }
        </>
      </div>

      <div className="d-flex align-items-center gap-2 justify-content-end px-10">
        <button className="btn btn-outline-white px-2 rounded" onClick={resetFinancialSummaryFilter}>Clear</button>
        <button className="btn btn-validate px-2 rounded" onClick={() => { handleApply(name); }}>Apply</button>
      </div>
    </div> : <></>;
  let searchFilterModal =
  {
    "SearchCriteria": {
      ...(['Line Chart Main'].includes(name) ? {} : { "Value": basedOnDateFinancial, }),
      ...(['Line Chart'].includes(name)
          ? { "Month": monthYear.monthNumber, "Year": monthYear.year, "PaymentFor": "" }
          : (['Line Chart Main'].includes(name) ? {} : { "InsuranceIDs": insuranceID })
      ),
      ...(['Line Chart', 'Payment Received'].includes(name) ? {} : { "LocationIDs": locationID }),
      ...(['Line Chart', 'Payment Received'].includes(name) ? {} : { "ProviderIDs": providerID, }),
      ...(['Financial Summary', 'Payment Received'].includes(name) ? { "PaymentFor": paymentForID, } : {}),
      ...extraSearchCriteria,
    }
  }

  if (name === 'Billing Performance') {
    return [setOpenFilter, searchFilterModal, filterDiv, setBasedOnDateFinancial, basedOnDateFinancial]
  }

  if (name === 'Line Chart Main') {
    return [setOpenFilter, searchFilterModal, filterDiv]

  }
  if (name === 'Payment Line Chart') {
    return [setOpenFilter, searchFilterModal, filterDiv, setBasedOnDateFinancial, basedOnDateFinancial, setPaymentForID, paymentForID]

  }

  if (name === 'Financial Summary') {
    return [setOpenFilter, searchFilterModal, filterDiv, setBasedOnDateFinancial, basedOnDateFinancial, setPaymentForID, paymentForID]

  }
  else if (name === 'Payment Received') {
    return [setOpenFilter, searchFilterModal, filterDiv, setPaymentForID, paymentForID]
  }
  else if (name === 'Aging_Payment_Received') {
    return [setOpenFilter, searchFilterModal, filterDiv, setBasedOnDateFinancial, basedOnDateFinancial, setPaymentForID, paymentForID]

  }

  // return [setOpenFilter, searchFilterModal, filterDiv,setBasedOnDateFinancial,basedOnDateFinancial,setPaymentForID,paymentForID]
}

export default useDashboardFilterHook